/**
 * 旧版本颜色
 */
const OldColors: Record<string, string> = {
  primary: "#CCAC85",
  "primary-50": "#F9F7F1",
  "primary-100": "#F3EDE1",
  "primary-200": "#E6D9C2",
  "primary-300": "#D6BF9B",
  "primary-400": "#CCAC85",
  "primary-500": "#B88956",
  "primary-600": "#AA754D",
  "primary-700": "#8E5F40",
  "primary-800": "#724D39",
  "primary-900": "#5E4130",
  "primary-950": "#312118",

  "text-strong": "#383533",
  "text-regular": "#61605F",
  "text-secondary": "#969390",
  "text-placeholder": "#C7C4C2",

  "border-first": "#E2DFDD",
  "border-second": "#F0EEEC",
  "border-third": "#F4F2F1",

  error: "#ec7d57",
};

/**
 * 颜色映射表
 */
const Colors: Record<string, string> = {
  "text-1": "#383533",
  "text-2": "#61605F",
  "text-3": "#969390",
  "text-4": "#C7C4C2",

  "primary-1": "#fbf8f1",
  "primary-2": "#f5eedf",
  "primary-3": "#e9d9bf",
  "primary-4": "#dbbe96",
  "primary-5": "#cc9e6c",
  "primary-6": "#c1854e",
  "primary-7": "#b37143",
  "primary-8": "#955a39",
  "primary-9": "#784a34",
  "primary-10": "#623e2c",

  "gray-1": "#ffffff",
  "gray-2": "#fafafa",
  "gray-3": "#f5f5f5",
  "gray-4": "#f0f0f0",
  "gray-5": "#d9d9d9",
  "gray-6": "#bfbfbf",
  "gray-7": "#8c8c8c",
  "gray-8": "#595959",
  "gray-9": "#434343",
  "gray-10": "#262626",
  "gray-11": "#1f1f1f",
  "gray-12": "#141414",
  "gray-13": "#000000",

  "red-1": "#fdf3f3",
  "red-2": "#fce5e4",
  "red-3": "#fad0ce",
  "red-4": "#f6aeab",
  "red-5": "#ee7f7b",
  "red-6": "#e5645f",
  "red-7": "#cf3933",
  "red-8": "#ae2c27",
  "red-9": "#902924",
  "red-10": "#782724",

  "orange-1": "#fcf6f4",
  "orange-2": "#faece6",
  "orange-3": "#f7dcd1",
  "orange-4": "#f1c2b0",
  "orange-5": "#e5987a",
  "orange-6": "#d97e5a",
  "orange-7": "#c5633d",
  "orange-8": "#a55130",
  "orange-9": "#89452b",
  "orange-10": "#723e2a",

  "yellow-1": "#fbf9ef",
  "yellow-2": "#f4edd1",
  "yellow-3": "#e8d99f",
  "yellow-4": "#d9bd62",
  "yellow-5": "#d3ad4c",
  "yellow-6": "#ca9336",
  "yellow-7": "#b2742d",
  "yellow-8": "#945729",
  "yellow-9": "#7a4626",
  "yellow-10": "#653a22",

  "green-1": "#f2f7f2",
  "green-2": "#e1ecdf",
  "green-3": "#c4d8c2",
  "green-4": "#99bd98",
  "green-5": "#6e9d6f",
  "green-6": "#4b7e4e",
  "green-7": "#38633c",
  "green-8": "#2d4f31",
  "green-9": "#254027",
  "green-10": "#1f3521",

  "glacier-1": "#f1f8fa",
  "glacier-2": "#dcecf1",
  "glacier-3": "#bedae3",
  "glacier-4": "#90cdd0",
  "glacier-5": "#73abbf",
  "glacier-6": "#40819a",
  "glacier-7": "#386a82",
  "glacier-8": "#33586b",
  "glacier-9": "#304b5a",
  "glacier-10": "#2c404d",

  "blue-1": "#f3f8fb",
  "blue-2": "#e5edf4",
  "blue-3": "#d0e0ed",
  "blue-4": "#b0cce0",
  "blue-5": "#8ab1d0",
  "blue-6": "#779ec7",
  "blue-7": "#5b81b5",
  "blue-8": "#506fa5",
  "blue-9": "#455c88",
  "blue-10": "#3b4d6d",

  "lavender-1": "#f0f1fd",
  "lavender-2": "#e4e6fb",
  "lavender-3": "#cfd2f6",
  "lavender-4": "#b2b4ef",
  "lavender-5": "#8d8ae5",
  "lavender-6": "#8378dc",
  "lavender-7": "#715dce",
  "lavender-8": "#624db5",
  "lavender-9": "#504192",
  "lavender-10": "#433a75",

  "purple-1": "#faf7fd",
  "purple-2": "#f3edfa",
  "purple-3": "#e9def6",
  "purple-4": "#d9c3ef",
  "purple-5": "#c19de3",
  "purple-6": "#b082d9",
  "purple-7": "#9359c4",
  "purple-8": "#7e46aa",
  "purple-9": "#693d8c",
  "purple-10": "#563271",

  "grass-1": "#f4f9f8",
  "grass-2": "#d9eee8",
  "grass-3": "#b3dcd1",
  "grass-4": "#6eb8a7",
  "grass-5": "#5ba697",
  "grass-6": "#418b7e",
  "grass-7": "#326f65",
  "grass-8": "#2c5953",
  "grass-9": "#264943",
  "grass-10": "#233e3a",

  "opacity-88": "rgba(0, 0, 0, 0.88)",
  "opacity-65": "rgba(0, 0, 0, 0.65)",
  "opacity-45": "rgba(0, 0, 0, 0.45)",
  "opacity-25": "rgba(0, 0, 0, 0.25)",
  "opacity-15": "rgba(0, 0, 0, 0.15)",
  "opacity-6": "rgba(0, 0, 0, 0.06)",
  "opacity-4": "rgba(0, 0, 0, 0.04)",
  "opacity-2": "rgba(0, 0, 0, 0.02)",
};

/**
 * 尺寸映射表
 */
const Size: Record<string, number> = {
  // font-size
  "font-size": 14,
  "font-size-sm": 12,
  "font-size-lg": 16,
  "font-size-xl": 20,
  "font-size-heading-1": 38,
  "font-size-heading-2": 30,
  "font-size-heading-3": 24,
  "font-size-heading-4": 20,
  "font-size-heading-5": 16,

  // border-radius
  "border-radius-xs": 2,
  "border-radius-sm": 4,
  "border-radius": 6,
  "border-radius-md": 8,
  "border-radius-lg": 12,
  "border-radius-xl": 16,

  // margin
  "margin-xxs": 4,
  "margin-xs": 8,
  "margin-sm": 12,
  margin: 16,
  "margin-md": 20,
  "margin-lg": 24,
  "margin-xl": 32,
  "margin-xxl": 48,

  // padding
  "padding-xxs": 4,
  "padding-xs": 8,
  "padding-sm": 12,
  padding: 16,
  "padding-md": 20,
  "padding-lg": 24,
  "padding-xl": 32,
};

/**
 * 规范颜色
 */
export const SpecificationColors = {
  ...OldColors,
  ...Colors,
};

/**
 * 规范尺寸
 */
export const SpecificationSize = {
  ...Size,
};

/**
 * UI 颜色和尺寸规范
 * @description 前端采用的梯度颜色，可以通过 tailwind 直接使用，后面避免直接使用颜色的值
 */
export const Specification = {
  ...SpecificationColors,
  ...Size,
};
